import React from "react";
import SubHeader from "../components/SubHeader";
import "./HowItWorks.css";
import understand from "../../../assets/img/step-icon1.png";
import schedule from "../../../assets/img/step-icon2.png";
import contact from "../../../assets/img/step-icon3.png";
import { Fade } from "react-reveal";

export default function HowItWorks() {
  const step = (stepNo, img, pTag) => (
    <div className="step">
      <div className="big-circle">
        <div className="small-circle">{stepNo}</div>
        <img src={img} alt="how vibes and vent works" />
      </div>
      <p>{pTag}</p>
    </div>
  );
  return (
    <Fade up>
      <section className="how-it-works" id="how-it-works">
        <SubHeader
          title={"Scheduling"}
          subheader={"How it works?"}
          align={true}
        />
        <div className="container">
          {step(1, schedule, "Book a free consultation.")}
          {step(2, understand, "Get matched with a therapist.")}
          {step(3, contact, "Schedule a session with them.")}
        </div>
      </section>
    </Fade>
  );
}
